export default "__VITE_ASSET__pheYYai0__"